<template>
	<div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
		style="overflow: hidden;">
		<el-row :gutter="20">
			<el-col :span="24">
				<div class="grid-content bg-white">
					<div class="ModularTitle">
						HIS数据上报情况
						<span style="font-size: 15px;padding-left: 25px;">本月已上报</span><span
							style="font-size: 15px;color:#67C23A;padding-left: 10px;cursor: pointer;"
							@click="UpHISCountVisible">{{UpHISCount}}</span><span
							style="font-size: 15px;padding-left: 10px;">条数据</span>
						<span style="font-size: 15px;padding-left: 25px;color: #F56C6C;cursor: pointer;"
							@click="UnUpHISCountVisible">{{UNUpHISCount}}</span><span
							style="font-size: 15px;padding-left: 10px;">条数据未上报</span>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20" style="padding-top: 24px;">
			<el-col :span="12">
				<div class="grid-content bg-white">
					<div class="ModularTitle">
						住培生
					</div>
					<div style="padding: 25px;">
						<el-row :gutter="20">
							<el-col :span="8">
								<div class="grid-content">
									<div style="width:100%;height: 80px;line-height: 80px;">
										<div class="ModularNumber" style="color:#67C23A;cursor: pointer;">	<!-- @click="INStuVisible" -->
											{{INStu}}<span style="font-size: 16px;padding-left: 5px;">人</span>
										</div>
										<div class="ModularName" style="color:#67C23A;">
											在培
										</div>
									</div>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="grid-content">
									<div class="ModularNumber" style="color: #F56C6C;cursor: pointer;"
										><!-- @click="LeaveStuVisible" -->
										{{LeaveStu}}<span style="font-size: 16px;padding-left: 5px;">人</span>
									</div>
									<div class="ModularName" style="color: #F56C6C;">
										缺勤
									</div>
								</div>
							</el-col>
							<el-col :span="8" v-show='false'>
								<div class="grid-content">
									<div class="ModularNumber" style="color: #E6A23C;cursor: pointer;"
										@click="DelayStuVisible">
										{{DelayStu}}<span style="font-size: 16px;padding-left: 5px;">人</span>
									</div>
									<div class="ModularName" style="color: #E6A23C;">
										延期
									</div>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="grid-content">
									<div class="ModularNumber" style="color: #409EFF;cursor: pointer;"
										><!-- @click="GraduationStuVisible" -->
										{{GraduationStu}}<span style="font-size: 16px;padding-left: 5px;">人</span>
									</div>
									<div class="ModularName" style="color: #409EFF;">
										结业
									</div>
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
			</el-col>
			<el-col :span="4">
				<div class="grid-content bg-white">
					<div class="ModularTitle">
						带教老师数
					</div>
					<div style="padding: 25px;">
						<el-row :gutter="20">
							<el-col :span="24">
								<div class="grid-content">
									<div class="ModularTecNumber" style="color: #409EFF;cursor: pointer;"
										><!-- @click="TecVisible" -->
										{{TecCount}}<span style="font-size: 16px;padding-left: 5px;">人</span>
									</div>
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content bg-white">
					<div class="ModularTitle">
						月度绩效评分次数
					</div>
					<div style="padding: 25px;">
						<el-row :gutter="20">
							<el-col :span="12">
								<div class="grid-content">
									<div style="width:100%;height: 80px;line-height: 80px;">
										<div class="ModularNumber" style="color: #67C23A;cursor: pointer;"
											><!-- @click="MonthStuVisible" -->
											{{StuMonthScore}}<span style="font-size: 16px;padding-left: 5px;">次</span>
										</div>
										<div class="ModularName" style="color: #67C23A;">
											住培生
										</div>
									</div>
								</div>
							</el-col>
							<el-col :span="12">
								<div class="grid-content">
									<div style="width:100%;height: 80px;line-height: 80px;">
										<div class="ModularNumber" style="color: #409EFF;cursor: pointer;"
											><!-- @click="MonthTecVisible" -->
											{{TecMonthScore}}<span style="font-size: 16px;padding-left: 5px;">次</span>
										</div>
										<div class="ModularName" style="color: #409EFF;">
											带教老师
										</div>
									</div>
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20" style="padding-top: 24px;">
			<el-col :span="10">
				<div class="grid-content bg-white">
					<div class="ModularTitle">
						住培生月度评分
					</div>
					<div style="padding: 25px;">
						<el-row :gutter="20">
							<el-col :span="24">
								<div class="grid-content">
									<div style="width:100%;height: 168px;">
										<div id="chartdiv"></div>
									</div>
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
			</el-col>
			<el-col :span="14">
				<div class="grid-content bg-white">
					<div class="ModularTitle">
						本月未入科住培生
					</div>
					<div style="padding: 25px;height: 218px;overflow: auto;">
						<el-table :data="tableData" stripe style="width: 100%" size="medium" v-loading="loading">
							<el-table-column prop="CPStuName" label="姓名">
							</el-table-column>
							<el-table-column prop="CPStuNo" label="工号">
							</el-table-column>
							<el-table-column prop="SecName" label="待入科室">
							</el-table-column>
						</el-table>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20" style="padding-top: 24px;">
			<el-col :span="24">
				<div class="grid-content bg-white">
					<div class="ModularTitle">
						当月数据
					</div>
					<div style="padding: 25px;">
						<el-row :gutter="20">
							<el-col :span="2" style="height: 1px;"></el-col>
							<el-col :span="4">
								<div class="grid-content">
									<div style="width:100%;height: 80px;line-height: 80px;">
										<div class="ModularNumber" style="color:#409EFF;cursor: pointer;">
											{{CycleStuNumber}}<span style="font-size: 16px;padding-left: 5px;">人</span>
										</div>
										<div class="ModularName" style="color:#409EFF;">
											轮转学员数
										</div>
									</div>
								</div>
							</el-col>
							<el-col :span="4">
								<div class="grid-content">
									<div style="width:100%;height: 80px;line-height: 80px;">
										<div class="ModularNumber" style="color:#67C23A;cursor: pointer;">
											{{EntryStuNumber}}<span style="font-size: 16px;padding-left: 5px;">人</span>
										</div>
										<div class="ModularName" style="color:#67C23A;">
											已入科数
										</div>
									</div>
								</div>
							</el-col>
							<el-col :span="4">
								<div class="grid-content">
									<div style="width:100%;height: 80px;line-height: 80px;">
										<div class="ModularNumber" style="color: #E6A23C;cursor: pointer;">
											{{NoEntryStuNumber}}<span
												style="font-size: 16px;padding-left: 5px;">人</span>
										</div>
										<div class="ModularName" style="color: #E6A23C;">
											未入科数
										</div>
									</div>
								</div>
							</el-col>
							<el-col :span="4">
								<div class="grid-content">
									<div style="width:100%;height: 80px;line-height: 80px;">
										<div class="ModularNumber" style="color: #F56C6C;cursor: pointer;"
											@click="ShowLeave">
											{{LeaveStuNumber}}<span style="font-size: 16px;padding-left: 5px;">人</span>
										</div>
										<div class="ModularName" style="color: #F56C6C;">
											请假数
										</div>
									</div>
								</div>
							</el-col>
							<el-col :span="4">
								<div class="grid-content">
									<div style="width:100%;height: 80px;line-height: 80px;">
										<div class="ModularNumber" style="color: #409EFF;cursor: pointer;">
											{{TecNumber}}<span style="font-size: 16px;padding-left: 5px;">人</span>
										</div>
										<div class="ModularName" style="color: #409EFF;">
											带教老师数
										</div>
									</div>
								</div>
							</el-col>
							<el-col :span="2" style="height: 1px;"></el-col>
						</el-row>
					</div>
				</div>
			</el-col>
		</el-row>

		<el-dialog width="80%" title="本月已上报HIS数据" :visible.sync="dialogUpHISCountVisible">
			<div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
				<el-button type="primary" icon="el-icon-download" @click="OutUpHIS"
					v-loading.fullscreen.lock="fullscreenLoading">导出</el-button>
			</div>
			<div class="m-portlet__body" style="max-height: 300px;overflow: auto;">
				<el-table :data="UpHISTableData" stripe style="width: 100%" size="medium" v-loading="loading">
					<el-table-column prop="StuName" label="姓名">
					</el-table-column>
					<el-table-column prop="StuNo" label="工号">
					</el-table-column>
					<el-table-column prop="SpecialityName" label="专业">
					</el-table-column>
					<el-table-column prop="UserTypeName" label="用户类型">
					</el-table-column>
					<el-table-column prop="StuEduYearName" label="培养年限">
					</el-table-column>
					<el-table-column prop="StuYearName" label="届别">
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
		<el-dialog width="80%" title="未上报HIS数据" :visible.sync="dialogUnUpHISCountVisible">
			<div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
				<el-button type="primary" icon="el-icon-download" @click="OutUnUpHIS"
					v-loading.fullscreen.lock="fullscreenLoading">导出</el-button>
			</div>
			<div class="m-portlet__body" style="max-height: 300px;overflow: auto;">
				<el-table :data="UnUpHISTableData" stripe style="width: 100%" size="medium" v-loading="loading">
					<el-table-column prop="StuName" label="姓名">
					</el-table-column>
					<el-table-column prop="StuNo" label="工号">
					</el-table-column>
					<el-table-column prop="SectionName" label="科室">
					</el-table-column>
					<el-table-column prop="SpecialityName" label="专业">
					</el-table-column>
					<el-table-column prop="UserTypeName" label="用户类型">
					</el-table-column>
					<el-table-column prop="StuEduYearName" label="培养年限">
					</el-table-column>
					<el-table-column prop="StuYearName" label="届别">
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
		<el-dialog width="80%" title="在培住培生数据" :visible.sync="dialogINStuVisible">
			<div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
				<el-button type="primary" icon="el-icon-download" @click="OutINStu"
					v-loading.fullscreen.lock="fullscreenLoading">导出</el-button>
			</div>
			<div class="m-portlet__body" style="max-height: 300px;overflow: auto;">
				<el-table :data="INStuTableData" stripe style="width: 100%" size="medium" v-loading="loading">
					<el-table-column prop="StuName" label="姓名">
					</el-table-column>
					<el-table-column prop="StuNo" label="工号">
					</el-table-column>
					<el-table-column prop="ManageSecName" label="管理单元">
					</el-table-column>
					<el-table-column prop="SectionName" label="轮转科室">
					</el-table-column>
					<el-table-column prop="SpecialityName" label="专业">
					</el-table-column>
					<el-table-column prop="UserTypeName" label="用户类型">
					</el-table-column>
					<el-table-column prop="StuEduYearName" label="培养年限">
					</el-table-column>
					<el-table-column prop="StuYearName" label="届别">
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
		<el-dialog width="80%" title="缺勤住培生数据" :visible.sync="dialogLeaveStuVisible">
			<div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
				<el-button type="primary" icon="el-icon-download" @click="OutLeaveStu"
					v-loading.fullscreen.lock="fullscreenLoading">导出</el-button>
			</div>
			<div class="m-portlet__body" style="max-height: 300px;overflow: auto;">
				<el-table :data="LeaveStuTableData" stripe style="width: 100%" size="medium" v-loading="loading">
					<el-table-column prop="StuName" label="姓名">
					</el-table-column>
					<el-table-column prop="StuNo" label="工号">
					</el-table-column>
					<el-table-column prop="SectionName" label="科室">
					</el-table-column>
					<el-table-column prop="SpecialityName" label="专业">
					</el-table-column>
					<el-table-column prop="UserTypeName" label="用户类型">
					</el-table-column>
					<el-table-column prop="StuEduYearName" label="培养年限">
					</el-table-column>
					<el-table-column prop="StuYearName" label="届别">
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
		<el-dialog width="80%" title="延期住培生数据" :visible.sync="dialogDelayStuVisible">
			<div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
				<el-button type="primary" icon="el-icon-download" @click="OutDelayStu"
					v-loading.fullscreen.lock="fullscreenLoading">导出</el-button>
			</div>
			<div class="m-portlet__body" style="max-height: 300px;overflow: auto;">
				<el-table :data="DelayStuTableData" stripe style="width: 100%" size="medium" v-loading="loading">
					<el-table-column prop="StuName" label="姓名">
					</el-table-column>
					<el-table-column prop="StuNo" label="工号">
					</el-table-column>
					<el-table-column prop="SectionName" label="科室">
					</el-table-column>
					<el-table-column prop="SpecialityName" label="专业">
					</el-table-column>
					<el-table-column prop="UserTypeName" label="用户类型">
					</el-table-column>
					<el-table-column prop="StuEduYearName" label="培养年限">
					</el-table-column>
					<el-table-column prop="StuYearName" label="届别">
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
		<el-dialog width="80%" title="结业住培生数据" :visible.sync="dialogGraduationStuVisible">
			<div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
				<el-button type="primary" icon="el-icon-download" @click="OutGraduationStu"
					v-loading.fullscreen.lock="fullscreenLoading">导出</el-button>
			</div>
			<div class="m-portlet__body" style="max-height: 300px;overflow: auto;">
				<el-table :data="GraduationStuTableData" stripe style="width: 100%" size="medium" v-loading="loading">
					<el-table-column prop="StuName" label="姓名">
					</el-table-column>
					<el-table-column prop="StuNo" label="工号">
					</el-table-column>
					<el-table-column prop="SectionName" label="科室">
					</el-table-column>
					<el-table-column prop="SpecialityName" label="专业">
					</el-table-column>
					<el-table-column prop="UserTypeName" label="用户类型">
					</el-table-column>
					<el-table-column prop="StuEduYearName" label="培养年限">
					</el-table-column>
					<el-table-column prop="StuYearName" label="届别">
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
		<el-dialog width="80%" title="带教老师数据" :visible.sync="dialogTecVisible">
			<div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
				<el-button type="primary" icon="el-icon-download" @click="OutTec"
					v-loading.fullscreen.lock="fullscreenLoading">
					导出</el-button>
			</div>
			<div class="m-portlet__body" style="max-height: 300px;overflow: auto;">
				<el-table :data="TecTableData" stripe style="width: 100%;" size="medium" v-loading="loading">
					<el-table-column prop="TrueName" label="姓名">
					</el-table-column>
					<el-table-column prop="CardNo" label="工号">
					</el-table-column>
					<el-table-column prop="SectionName" label="科室">
					</el-table-column>
					<el-table-column prop="EduName" label="学历">
					</el-table-column>
					<el-table-column prop="CurrentCount" label="现带教人数">
					</el-table-column>
					<el-table-column prop="TotalCount" label="总带教人数">
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
		<el-dialog width="80%" title="住培生月度绩效评分数据" :visible.sync="dialogMonthStuVisible">
			<div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
				<el-button type="primary" icon="el-icon-download" @click="OutMonthStu"
					v-loading.fullscreen.lock="fullscreenLoading">导出</el-button>
			</div>
			<div class="m-portlet__body" style="max-height: 300px;overflow: auto;">
				<el-table :data="MonthStuTableData" stripe style="width: 100%" size="medium" v-loading="loading">
					<el-table-column prop="CPIDName" label="姓名">
					</el-table-column>
					<el-table-column prop="CPIDNo" label="工号">
					</el-table-column>
					<el-table-column prop="CPIDSecName" label="科室">
					</el-table-column>
					<el-table-column prop="CPIDScore" label="得分">
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
		<el-dialog width="80%" title="带教老师月度绩效评分数据" :visible.sync="dialogMonthTecVisible">
			<div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
				<el-button type="primary" icon="el-icon-download" @click="OutMonthTec"
					v-loading.fullscreen.lock="fullscreenLoading">导出</el-button>
			</div>
			<div class="m-portlet__body" style="max-height: 300px;overflow: auto;">
				<el-table :data="MonthTecTableData" stripe style="width: 100%" size="medium" v-loading="loading">
					<el-table-column prop="CPIDName" label="姓名">
					</el-table-column>
					<el-table-column prop="CPIDNo" label="工号">
					</el-table-column>
					<el-table-column prop="CPIDSecName" label="科室">
					</el-table-column>
					<el-table-column prop="CPIDScore" label="得分">
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
		<el-dialog width="80%" title="待审核月度评分数据" :visible.sync="dialogCheckingMonthScoreVisible">
			<div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
				<el-button type="primary" icon="el-icon-download" @click="OutCheckingMonthScore"
					v-loading.fullscreen.lock="fullscreenLoading">导出</el-button>
			</div>
			<div class="m-portlet__body" style="max-height: 300px;overflow: auto;">
				<el-table :data="CheckingMonthScoreTableData" stripe style="width: 100%" size="medium"
					v-loading="loading">
					<el-table-column prop="SecName" label="轮转科室">
					</el-table-column>
					<el-table-column label="月度">
						<template slot-scope="scope">
							{{scope.row.CPIDate|formatDate}}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
		<el-dialog width="80%" title="已审核月度评分数据" :visible.sync="dialogCheckedMonthScoreVisible">
			<div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
				<el-button type="primary" icon="el-icon-download" @click="OutCheckedMonthScore"
					v-loading.fullscreen.lock="fullscreenLoading">导出</el-button>
			</div>
			<div class="m-portlet__body" style="max-height: 300px;overflow: auto;">
				<el-table :data="CheckedMonthScoreTableData" stripe style="width: 100%" size="medium"
					v-loading="loading">
					<el-table-column prop="SecName" label="轮转科室">
					</el-table-column>
					<el-table-column label="月度">
						<template slot-scope="scope">
							{{scope.row.CPIDate|formatDate}}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
		<el-dialog width="80%" title="被退回月度评分数据" :visible.sync="dialogBackMonthScoreVisible">
			<div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
				<el-button type="primary" icon="el-icon-download" @click="OutBackMonthScore"
					v-loading.fullscreen.lock="fullscreenLoading">导出</el-button>
			</div>
			<div class="m-portlet__body" style="max-height: 300px;overflow: auto;">
				<el-table :data="BackMonthScoreTableData" stripe style="width: 100%" size="medium" v-loading="loading">
					<el-table-column prop="SecName" label="轮转科室">
					</el-table-column>
					<el-table-column label="月度">
						<template slot-scope="scope">
							{{scope.row.CPIDate|formatDate}}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
		<el-dialog width="60%" title="请假人员列表" :visible.sync="dialogLeaveVisible">
			<div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">

			</div>
			<div class="m-portlet__body" style="max-height: 300px;overflow: auto;">
				<el-table :data="LeaveData" stripe style="width: 100%" size="medium" v-loading="loading">
					<el-table-column prop="StuName" label="姓名" width="120">
					</el-table-column>
					<el-table-column prop="StuNo" label="工号" width="120">
					</el-table-column>
					<el-table-column prop="LeaveReason" label="请假事由">
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import * as am4core from "@amcharts/amcharts4/core"
	import * as am4charts from "@amcharts/amcharts4/charts"
	export default {
		name: 'IndexSystem',
		data() {
			return {
				token: '',
				username: '',
				rolelevel: '',
				secid: '',
				UpHISCount: '0',
				UNUpHISCount: '0',
				INStu: '0',
				LeaveStu: '0',
				DelayStu: '0',
				GraduationStu: '0',
				TecCount: '0',
				StuMonthScore: '0',
				TecMonthScore: '0',
				tableData: [],
				monthscore: [],
				dialogUpHISCountVisible: false,
				UpHISTableData: null,
				dialogUnUpHISCountVisible: false,
				UnUpHISTableData: null,
				dialogINStuVisible: false,
				INStuTableData: null,
				dialogLeaveStuVisible: false,
				LeaveStuTableData: null,
				dialogDelayStuVisible: false,
				DelayStuTableData: null,
				dialogGraduationStuVisible: false,
				GraduationStuTableData: null,
				dialogTecVisible: false,
				TecTableData: null,
				dialogMonthStuVisible: false,
				MonthStuTableData: null,
				dialogMonthTecVisible: false,
				MonthTecTableData: null,
				dialogCheckingMonthScoreVisible: false,
				CheckingMonthScoreTableData: null,
				dialogCheckedMonthScoreVisible: false,
				CheckedMonthScoreTableData: null,
				dialogBackMonthScoreVisible: false,
				BackMonthScoreTableData: null,
				loading: true,
				fullscreenLoading: false,
				CycleStuNumber: '0',
				EntryStuNumber: '0',
				NoEntryStuNumber: '0',
				LeaveStuNumber: '0',
				TecNumber: '0',
				dialogLeaveVisible: false,
				LeaveData: []
			}
		},
		filters: {
			formatDate(val) {
				var now = new Date(val)
				var y = now.getFullYear()
				var m = now.getMonth() + 1
				return y + '-' + (m < 10 ? '0' + m : m)
			}
		},
		methods: {
			OutBackMonthScore: function() {
				this.fullscreenLoading = true
				var args = {
					token: this.token,
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/BackMonthScoreOut', args)
					.then(res => {
						if (res.data.Code === 0) {
							var filename = res.data.Data
							var url = this.$utils.Url.zpgl + '/doc/' + filename
							window.open(url)
						}
						this.fullscreenLoading = false
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '导出失败',
							type: 'error'
						})
						this.fullscreenLoading = false
					})
			},
			OutCheckedMonthScore: function() {
				this.fullscreenLoading = true
				var args = {
					token: this.token,
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/CheckedMonthScoreOut', args)
					.then(res => {
						if (res.data.Code === 0) {
							var filename = res.data.Data
							var url = this.$utils.Url.zpgl + '/doc/' + filename
							window.open(url)
						}
						this.fullscreenLoading = false
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '导出失败',
							type: 'error'
						})
						this.fullscreenLoading = false
					})
			},
			OutCheckingMonthScore: function() {
				this.fullscreenLoading = true
				var args = {
					token: this.token,
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/CheckingMonthScoreOut', args)
					.then(res => {
						if (res.data.Code === 0) {
							var filename = res.data.Data
							var url = this.$utils.Url.zpgl + '/doc/' + filename
							window.open(url)
						}
						this.fullscreenLoading = false
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '导出失败',
							type: 'error'
						})
						this.fullscreenLoading = false
					})
			},
			OutMonthTec: function() {
				this.fullscreenLoading = true
				var args = {
					token: this.token,
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/TecMonthListOut', args)
					.then(res => {
						if (res.data.Code === 0) {
							var filename = res.data.Data
							var url = this.$utils.Url.zpgl + '/doc/' + filename
							window.open(url)
						}
						this.fullscreenLoading = false
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '导出失败',
							type: 'error'
						})
						this.fullscreenLoading = false
					})
			},
			MonthTecVisible: function() {
				this.dialogMonthTecVisible = true
				this.loading = true
				var args = {
					token: this.token,
					username: this.username,
					rolelevel: this.rolelevel,
					secid: this.secid,
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/TecMonthList', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.MonthTecTableData = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.loading = false
					})
					.catch(err => {
						this.MonthTecTableData = null
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.loading = false
					})
			},
			OutMonthStu: function() {
				this.fullscreenLoading = true
				var args = {
					token: this.token,
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/StuMonthListOut', args)
					.then(res => {
						if (res.data.Code === 0) {
							var filename = res.data.Data
							var url = this.$utils.Url.zpgl + '/doc/' + filename
							window.open(url)
						}
						this.fullscreenLoading = false
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '导出失败',
							type: 'error'
						})
						this.fullscreenLoading = false
					})
			},
			MonthStuVisible: function() {
				this.dialogMonthStuVisible = true
				this.loading = true
				var args = {
					token: this.token,
					username: this.username,
					rolelevel: this.rolelevel,
					secid: this.secid,
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/StuMonthList', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.MonthStuTableData = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.loading = false
					})
					.catch(err => {
						this.MonthStuTableData = null
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.loading = false
					})
			},
			OutTec: function() {
				this.fullscreenLoading = true
				var args = {
					token: this.token,
					username: this.username,
					rolelevel: this.rolelevel,
					secid: this.secid,
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APITeacher/ListOut', args)
					.then(res => {
						if (res.data.Code === 0) {
							var filename = res.data.Data
							var url = this.$utils.Url.zpgl + '/doc/' + filename
							window.open(url)
						}
						this.fullscreenLoading = false
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '导出失败',
							type: 'error'
						})
						this.fullscreenLoading = false
					})
			},
			TecVisible: function() {
				this.dialogTecVisible = true
				this.loading = true
				var args = {
					token: this.token,
					username: this.username,
					rolelevel: this.rolelevel,
					secid: this.secid,
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APITeacher/List', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.TecTableData = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.loading = false
					})
					.catch(err => {
						this.TecTableData = null
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.loading = false
					})
			},
			OutGraduationStu: function() {
				this.fullscreenLoading = true
				var args = {
					token: this.token,
					username: this.username,
					rolelevel: this.rolelevel,
					secid: this.secid,
					stueditstatus: 5,
					filename: '结业住培生数据',
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/ListOut', args)
					.then(res => {
						if (res.data.Code === 0) {
							var filename = res.data.Data
							var url = this.$utils.Url.zpgl + '/doc/' + filename
							window.open(url)
						}
						this.fullscreenLoading = false
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '导出失败',
							type: 'error'
						})
						this.fullscreenLoading = false
					})
			},
			GraduationStuVisible: function() {
				this.dialogGraduationStuVisible = true
				this.loading = true
				var args = {
					token: this.token,
					username: this.username,
					rolelevel: this.rolelevel,
					secid: this.secid,
					stueditstatus: 5,
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/List', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.GraduationStuTableData = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.loading = false
					})
					.catch(err => {
						this.GraduationStuTableData = null
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.loading = false
					})
			},
			OutDelayStu: function() {
				this.fullscreenLoading = true
				var args = {
					token: this.token,
					username: this.username,
					rolelevel: this.rolelevel,
					secid: this.secid,
					stueditstatus: 4,
					filename: '延期住培生数据',
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/ListOut', args)
					.then(res => {
						if (res.data.Code === 0) {
							var filename = res.data.Data
							var url = this.$utils.Url.zpgl + '/doc/' + filename
							window.open(url)
						}
						this.fullscreenLoading = false
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '导出失败',
							type: 'error'
						})
						this.fullscreenLoading = false
					})
			},
			DelayStuVisible: function() {
				this.dialogDelayStuVisible = true
				this.loading = true
				var args = {
					token: this.token,
					username: this.username,
					rolelevel: this.rolelevel,
					secid: this.secid,
					stueditstatus: 4,
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/List', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.DelayStuTableData = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.loading = false
					})
					.catch(err => {
						this.DelayStuTableData = null
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.loading = false
					})
			},
			OutLeaveStu: function() {
				this.fullscreenLoading = true
				var args = {
					token: this.token,
					username: this.username,
					rolelevel: this.rolelevel,
					secid: this.secid,
					stueditstatus: 3,
					filename: '缺勤住培生数据',
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/ListOut', args)
					.then(res => {
						if (res.data.Code === 0) {
							var filename = res.data.Data
							var url = this.$utils.Url.zpgl + '/doc/' + filename
							window.open(url)
						}
						this.fullscreenLoading = false
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '导出失败',
							type: 'error'
						})
						this.fullscreenLoading = false
					})
			},
			LeaveStuVisible: function() {
				this.dialogLeaveStuVisible = true
				this.loading = true
				var args = {
					token: this.token,
					username: this.username,
					rolelevel: this.rolelevel,
					secid: this.secid,
					stueditstatus: 3,
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/List', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.LeaveStuTableData = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.loading = false
					})
					.catch(err => {
						this.LeaveStuTableData = null
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.loading = false
					})
			},
			OutINStu: function() {
				this.fullscreenLoading = true
				var args = {
					token: this.token
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/INStuListOut', args)
					.then(res => {
						if (res.data.Code === 0) {
							var filename = res.data.Data
							var url = this.$utils.Url.zpgl + '/doc/' + filename
							window.open(url)
						}
						this.fullscreenLoading = false
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '导出失败',
							type: 'error'
						})
						this.fullscreenLoading = false
					})
			},
			INStuVisible: function() {
				this.dialogINStuVisible = true
				this.loading = true
				var args = {
					token: this.token
				}
				var that = this
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/INStuList', args)
					.then(res => {
						if (res.data.Code === 0) {
							that.INStuTableData = res.data.Data
						} else {
							that.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						that.loading = false
					})
					.catch(err => {
						that.INStuTableData = null
						console.log(err)
						that.$message({
							message: '查询失败',
							type: 'error'
						})
						that.loading = false
					})
			},
			OutUnUpHIS: function() {
				this.fullscreenLoading = true
				var args = {
					token: this.token,
					username: this.username,
					rolelevel: this.rolelevel,
					secid: this.secid,
					stustatus: 3,
					filename: '未上报HIS数据',
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/ListOut', args)
					.then(res => {
						if (res.data.Code === 0) {
							var filename = res.data.Data
							var url = this.$utils.Url.zpgl + '/doc/' + filename
							window.open(url)
						}
						this.fullscreenLoading = false
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '导出失败',
							type: 'error'
						})
						this.fullscreenLoading = false
					})
			},
			UnUpHISCountVisible: function() {
				this.dialogUnUpHISCountVisible = true
				this.loading = true
				var args = {
					token: this.token,
					stustatus: 3,
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/List', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.UnUpHISTableData = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.loading = false
					})
					.catch(err => {
						this.UnUpHISTableData = null
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.loading = false
					})
			},
			OutUpHIS: function() {
				this.fullscreenLoading = true
				var date = new Date()
				var year = date.getFullYear()
				var month = date.getMonth() + 1
				if (month >= 1 && month <= 9) {
					month = '0' + month
				}
				var UpHISDate = year + '-' + month
				var args = {
					token: this.token,
					uphisdate: UpHISDate,
					filename: '本月已上报HIS数据',
					stustatus: 2,
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/ListOut', args)
					.then(res => {
						if (res.data.Code === 0) {
							var filename = res.data.Data
							var url = this.$utils.Url.zpgl + '/doc/' + filename
							window.open(url)
						}
						this.fullscreenLoading = false
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '导出失败',
							type: 'error'
						})
						this.fullscreenLoading = false
					})
			},
			UpHISCountVisible: function() {
				this.dialogUpHISCountVisible = true
				var date = new Date()
				var year = date.getFullYear()
				var month = date.getMonth() + 1
				if (month >= 1 && month <= 9) {
					month = '0' + month
				}
				var UpHISDate = year + '-' + month
				this.loading = true
				var args = {
					token: this.token,
					uphisdate: UpHISDate,
					stustatus: 2,
					currentPage: 1,
					pageSize: 99999
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/List', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.UpHISTableData = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.loading = false
					})
					.catch(err => {
						this.UpHISTableData = null
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.loading = false
					})
			},
			LoadUPHISCount: function() {
				var args = {
					token: this.token
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/UpHISCount', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.UpHISCount = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.LoadUNUPHISCount()
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.LoadUNUPHISCount()
					})
			},
			LoadUNUPHISCount: function() {
				var args = {
					token: this.token
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/UNUpHISCount', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.UNUpHISCount = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.LoadINStu()
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.LoadINStu()
					})
			},
			//在培
			LoadINStu: function() {
				var args = {
					token: this.token
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/INStu', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.INStu = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.LoadLeaveStu()
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.LoadLeaveStu()
					})
			},
			//缺勤
			LoadLeaveStu: function() {
				var args = {
					token: this.token
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/LeaveStu', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.LeaveStu = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.LoadDelayStu()
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.LoadDelayStu()
					})
			},
			LoadDelayStu: function() {
				var args = {
					token: this.token
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/DelayStu', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.DelayStu = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.LoadGraduationStu()
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.LoadGraduationStu()
					})
			},
			LoadGraduationStu: function() {
				var args = {
					token: this.token
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/GraduationStu', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.GraduationStu = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.LoadTecCount()
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.LoadTecCount()
					})
			},
			//带教老师数
			LoadTecCount: function() {
				var args = {
					token: this.token
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APITeacher/TecCount', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.TecCount = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.LoadStuMonthScore()
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.LoadStuMonthScore()
					})
			},
			LoadStuMonthScore: function() {
				var args = {
					token: this.token
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/StuMonthScore', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.StuMonthScore = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.LoadTecMonthScore()
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.LoadTecMonthScore()
					})
			},
			LoadTecMonthScore: function() {
				var args = {
					token: this.token
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/TecMonthScore', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.TecMonthScore = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.LoadMonthScore()
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.LoadMonthScore()
					})
			},
			LoadMonthScore: function() {
				var args = {
					token: this.token
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/MonthScore', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.monthscore = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.LoadChart()
					})
					.catch(err => {
						this.monthscore = []
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.LoadChart()
					})
			},
			LoadChart: function() {
				var that = this
				var chart = am4core.create("chartdiv", am4charts.PieChart)
				chart.data = eval(this.monthscore)
				var pieSeries = chart.series.push(new am4charts.PieSeries())
				pieSeries.colors.list = [
					am4core.color("#FF9671"),
					am4core.color("#FFC75F")
				];
				pieSeries.name = '{category}'
				pieSeries.dataFields.value = "litres"
				pieSeries.dataFields.category = "country"
				chart.innerRadius = am4core.percent(50)
				pieSeries.labels.template.disabled = true
				pieSeries.ticks.template.disabled = true
				pieSeries.legendSettings.labelText = '{category}'
				pieSeries.legendSettings.valueText = '{value}条'
				pieSeries.slices.template.tooltipText = ""
				chart.legend = new am4charts.Legend()
				var markerTemplate = chart.legend.markers.template;
				markerTemplate.width = 30;
				markerTemplate.height = 5;
				chart.legend.position = "right"
				chart.legend.itemContainers.template.events.on("hit", function(ev) {
					var StatusName = ev.target.dataItem.name
					var args
					if (StatusName == "待审核") {
						that.dialogCheckingMonthScoreVisible = true
						that.loading = true
						args = {
							token: that.token,
							currentPage: 1,
							pageSize: 99999
						}
						that.$http.post(that.$utils.Url.zpgl + '/api/APICPI/CheckingMonthScore', args)
							.then(res => {
								if (res.data.Code === 0) {
									that.CheckingMonthScoreTableData = res.data.Data
								} else {
									that.$message({
										message: res.data.Msg + '，' + res.data.Error,
										type: 'error'
									})
								}
								that.loading = false
							})
							.catch(err => {
								that.CheckingMonthScoreTableData = null
								console.log(err)
								that.$message({
									message: '查询失败',
									type: 'error'
								})
								that.loading = false
							})
					} else if (StatusName == "已审核") {
						that.dialogCheckedMonthScoreVisible = true
						that.loading = true
						args = {
							token: that.token,
							currentPage: 1,
							pageSize: 99999
						}
						that.$http.post(that.$utils.Url.zpgl + '/api/APICPI/CheckedMonthScore', args)
							.then(res => {
								if (res.data.Code === 0) {
									that.CheckedMonthScoreTableData = res.data.Data
								} else {
									that.$message({
										message: res.data.Msg + '，' + res.data.Error,
										type: 'error'
									})
								}
								that.loading = false
							})
							.catch(err => {
								that.CheckedMonthScoreTableData = null
								console.log(err)
								that.$message({
									message: '查询失败',
									type: 'error'
								})
								that.loading = false
							})
					} else if (StatusName == "被退回") {
						that.dialogBackMonthScoreVisible = true
						that.loading = true
						args = {
							token: that.token,
							currentPage: 1,
							pageSize: 99999
						}
						that.$http.post(that.$utils.Url.zpgl + '/api/APICPI/BackMonthScore', args)
							.then(res => {
								if (res.data.Code === 0) {
									that.BackMonthScoreTableData = res.data.Data
								} else {
									that.$message({
										message: res.data.Msg + '，' + res.data.Error,
										type: 'error'
									})
								}
								that.loading = false
							})
							.catch(err => {
								that.BackMonthScoreTableData = null
								console.log(err)
								that.$message({
									message: '查询失败',
									type: 'error'
								})
								that.loading = false
							})
					} else {
						console.log("err")
					}
				})
				this.LoadUnInStu()
			},
			LoadUnInStu: function() {
				this.loading = true
				var args = {
					token: this.token
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/UnInStu', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.tableData = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.LoadMonth()
						this.loading = false
					})
					.catch(err => {
						this.tableData = []
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.LoadMonth()
						this.loading = false
					})
			},
			LoadMonth() {
				var args = {
					token: this.token
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/LoadMonth', args)
					.then(res => {
						if (res.data.Code === 0) {
							var info = res.data.Data
							console.log(info)
							this.CycleStuNumber = info.CycleStuNumber
							this.EntryStuNumber = info.EntryStuNumber
							this.NoEntryStuNumber = info.NoEntryStuNumber
							this.LeaveStuNumber = info.LeaveStuNumber
							this.TecNumber = info.TecNumber
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
					})
			},
			ShowLeave: function() {
				var args = {
					token: this.token
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/LoadMonthLeave', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.LeaveData = res.data.Data.ds
							console.log(res.data.Data.ds)
							this.dialogLeaveVisible = true
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
					})
			}
		},
		mounted: function() {
			this.token = sessionStorage.getItem('token')
			this.username = sessionStorage.getItem('username')
			this.rolelevel = sessionStorage.getItem('rolelevel')
			this.secid = sessionStorage.getItem('secid')
			if (this.rolelevel == 2) {
				this.$router.push('/main/index/section')
			} else {
				this.LoadUPHISCount()
			}
		}
	}
</script>

<style scoped="scoped">
	.ModularTitle {
		width: 100%;
		height: 50px;
		line-height: 50px;
		margin-left: 20px;
		font-size: 18px;
	}

	.ModularNumber {
		width: 100%;
		height: 50px;
		line-height: 50px;
		font-size: 35px;
		color: #FFFFFF;
		text-align: center;
	}

	.ModularName {
		width: 100%;
		height: 30px;
		line-height: 30px;
		font-size: 12px;
		color: #FFFFFF;
		text-align: center;
	}

	.ModularTecNumber {
		width: 100%;
		height: 80px;
		line-height: 80px;
		font-size: 35px;
		color: #FFFFFF;
		text-align: center;
	}

	.grid-content {
		border-radius: 5px;
	}
</style>
